// extracted by mini-css-extract-plugin
export var divider = "_th-0";